import {
  STOP_LOADING,
  ERROR,
  SUCCESS,
  TRANS_POSTING_DETAILS_RESET,
} from "../types/index";

export const resetFields = (id) => (dispatch) => {
  try {
    dispatch({ type: TRANS_POSTING_DETAILS_RESET });
    dispatch({ type: STOP_LOADING });
    dispatch({ type: SUCCESS });
  } catch (error) {
    dispatch({ type: ERROR, payload: error });
  }
};
